// extracted by mini-css-extract-plugin
module.exports = {"shareModal_wrap":"ShareModal_shareModal_wrap__3CAPA"};